// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoomAirflow
 */
export interface RoomAirflow {
    /**
     * Minimum airflow value
     */
    min: number | null;
    /**
     * Maximum airflow value
     */
    max: number | null;
}

/**
 * Check if a given object implements the RoomAirflow interface.
 */
export function instanceOfRoomAirflow(value: object): value is RoomAirflow {
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    return true;
}

export function RoomAirflowFromJSON(json: any): RoomAirflow {
    return RoomAirflowFromJSONTyped(json, false);
}

export function RoomAirflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomAirflow {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'],
        'max': json['max'],
    };
}

export function RoomAirflowToJSON(json: any): RoomAirflow {
    return RoomAirflowToJSONTyped(json, false);
}

export function RoomAirflowToJSONTyped(value?: RoomAirflow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

